import {FC, Card, PropsWithChildren} from 'external/react'

import ButtonBack from 'components/ButtonBack'

import BasicLayout from './BasicLayout'
import Icon, { IconName } from 'external/fortawesome'

type ButtonBackContainerProps = PropsWithChildren & {
    backTo?: string,
    iconName: IconName,
    label: string
}
const ButtonBackContainer: FC<ButtonBackContainerProps> = props => {

    const {iconName, backTo = '/home', label, children} = props

    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path={backTo} />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name={iconName} /> {label}
                </div>
            </Card.Header>
            {children}
        </BasicLayout>
    )
}

export {ButtonBackContainer as default}